import { el } from './dom';

export type RenameValidate = (name: string) => string;

let mask: HTMLDivElement | null = null;
let onOk: ((name: string) => void) | null = null;
let validate: RenameValidate | null = null;

function ensureModal(): HTMLDivElement {
  if (mask) return mask;

  mask = el('div', { className: 'modal-mask', id: 'renameModal' }) as HTMLDivElement;
  mask.setAttribute('role', 'dialog');
  mask.setAttribute('aria-modal', 'true');

  const box = el('div', { className: 'modal-box' });
  const title = el('div', { className: 'modal-title', id: 'renameModalTitle' }, 'Rename');
  const input = el('input', {
    id: 'renameModalInput',
    type: 'text',
    autocomplete: 'off',
    autocapitalize: 'words',
    spellcheck: 'false',
  }) as HTMLInputElement;
  const err = el('div', { className: 'modal-err', id: 'renameModalErr' });
  const actions = el('div', { className: 'modal-actions' });
  const cancel = el('button', { className: 'btn btn-ghost', type: 'button' }, 'Cancel') as HTMLButtonElement;
  const ok = el('button', { className: 'btn', type: 'button' }, 'Save') as HTMLButtonElement;

  cancel.onclick = () => closeRenameModal();
  ok.onclick = () => submitRenameModal();
  input.onkeydown = (e) => {
    if (e.key === 'Enter') submitRenameModal();
    if (e.key === 'Escape') closeRenameModal();
  };
  mask.onclick = (e) => {
    if (e.target === mask) closeRenameModal();
  };

  actions.append(cancel, ok);
  box.append(title, input, err, actions);
  mask.append(box);
  document.body.appendChild(mask);
  return mask;
}

export function openRenameModal(
  title: string,
  current: string,
  validateFn: RenameValidate,
  onOkFn: (name: string) => void,
): void {
  ensureModal();
  onOk = onOkFn;
  validate = validateFn;
  const titleEl = document.getElementById('renameModalTitle')!;
  const input = document.getElementById('renameModalInput') as HTMLInputElement;
  const err = document.getElementById('renameModalErr')!;
  titleEl.textContent = title;
  input.value = current;
  err.textContent = '';
  mask!.classList.add('on');
  window.setTimeout(() => {
    input.focus();
    input.select();
  }, 50);
}

export function closeRenameModal(): void {
  if (!mask) return;
  mask.classList.remove('on');
  onOk = null;
  validate = null;
}

function cleanTypedName(raw: string): string {
  return raw.trim().replace(/\s+/g, ' ');
}

function submitRenameModal(): void {
  const input = document.getElementById('renameModalInput') as HTMLInputElement;
  const err = document.getElementById('renameModalErr')!;
  const nm = cleanTypedName(input.value);
  const msg = validate ? validate(nm) : '';
  if (msg) {
    err.textContent = msg;
    return;
  }
  const cb = onOk;
  closeRenameModal();
  if (cb && nm) cb(nm);
}
